import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { User } from '../User'

@InputType()
export class SetUserEmailSignatureArgs extends ActionArgs {
  @Field(() => String, { nullable: true })
  emailSignature?: string

  userId?: unknown
}

export interface ISetUserEmailSignature extends IAction<User, SetUserEmailSignatureArgs> {}
